import { useIntl } from 'react-intl';

const useMultiLanguageVisitedLog = () => {
  const intl = useIntl();

  const VISITED_LOG_LIST_TITLE = intl.formatMessage({
    id: 'authentication.visitedLogList.title',
  });

  return { VISITED_LOG_LIST_TITLE };
};

export default useMultiLanguageVisitedLog;
